@import '../../styles/palette';

.error {
  background-color: _palette(warning-2);
}

.warning {
  background-color: _palette(warning-alert-bg);
}

.white {
  background-color: _palette(card);
}

.info {
  background-color: _palette(bg-hovered);
}

.defaultStyle {
  background-color: transparent;
  border-color: _palette(ghost);
}

.icon {
  font-size: 1.5625rem;
  opacity: 0.9;
}

.defaultIconColor {
  color: _palette(input-border-outlined);
}

.whiteIconColor {
  color: _palette(input-border-outlined);
}

.infoIconColor {
  color: _palette(text-hovered);
}

.warningIconColor {
  color: _palette(warning-alert-icon);
}

.errorIconColor {
  color: _palette(warning-1);
}

.message {
  display: flex;
  align-items: center;
  gap: 0.5em;
}
